import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComingSoonCta from '@/components/feature/ComingSoonCta';

const tracks = [
  { number: '01', title: 'Melodía del amanecer', desc: 'piano brillante, luz de la mañana' },
  { number: '02', title: 'La nana de las estrellas', desc: 'notas altas, como un cielo despejado' },
  { number: '03', title: 'Susurros de luna', desc: 'muy suave, íntimo, para las noches más tiernas' },
  { number: '04', title: 'El sueño dorado', desc: 'calidez, como sol filtrado por una cortina' },
  { number: '05', title: 'Pequeñas manos', desc: 'juguetón pero calmo, asombro infantil' },
  { number: '06', title: 'La canción sin nombre', desc: 'flotante, como una melodía a medio recordar' },
  { number: '07', title: 'Nana para dos', desc: 'diálogo suave entre dos voces de piano' },
  { number: '08', title: 'El último pensamiento', desc: 'el cierre del día, muy lento' },
  { number: '09', title: 'Durmiendo en paz', desc: 'casi silencio, como una respiración' },
  { number: '10', title: 'Hasta mañana', desc: 'la despedida tierna de la noche' },
];

const heroImage = 'https://readdy.ai/api/search-image?query=Digital%20art%20illustration%20in%20the%20style%20of%20premium%20editorial%20magazine%20cover%2C%20hyperrealistic%20digital%20render%20with%20soft%20painterly%20brush%20strokes%2C%20warm%20golden%20earth%20tones%2C%20soft%20textured%20lighting%2C%20a%20real%20mother%20gently%20rocking%20her%20baby%20in%20a%20vintage%20rocking%20chair%20at%20dusk%20with%20a%20soft%20bedside%20lamp%20glowing%20warm%20amber%20light%2C%20a%20small%20music%20box%20on%20the%20nightstand%2C%20warm%20cream%20and%20terracotta%20color%20palette%2C%20intimate%20evening%20ritual%2C%20mother%20looking%20down%20with%20calm%20and%20love%2C%20baby%20peacefully%20asleep%2C%20artistic%20yet%20photorealistic%2C%20editorial%20premium%20quality%2C%20not%20a%20stock%20photo%2C%20not%20cold%20or%20clinical%2C%20warm%20neutral%20palette%2C%20soft%20twilight%20ambiance%2C%20peaceful%20bedtime%20scene%2C%20nostalgic%20and%20tender%20atmosphere&width=1400&height=600&seq=271&orientation=landscape';

export default function AlbumLunaDeMiel() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />

      {/* Reading Progress Bar */}
      <div className="fixed top-0 left-0 w-full h-1 z-50">
        <div
          className="h-full bg-terracotta transition-all duration-150"
          style={{ width: '0%' }}
          id="reading-progress"
        />
      </div>

      {/* Hero Section */}
      <section className="relative pt-28 md:pt-36 pb-12 md:pb-20 px-6 md:px-10">
        <div className="w-full max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-16 items-start mb-10 md:mb-16">
            <div className="w-full md:w-1/2">
              <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
                {t('album_luna.tag')}
              </span>
              <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl font-bold text-[#8B6F5C] leading-tight">
                Melodías de Cuna<br />
                <span className="font-bold">Vol.1</span>
              </h1>
            </div>
            <div className="w-full md:w-1/2 flex flex-col justify-end md:pt-12">
              <p className="font-sans text-base md:text-lg text-[#3D2B1F] leading-relaxed mb-6">
                {t('album_luna.hero.desc')}
              </p>
              <div className="flex flex-wrap gap-3 mb-6">
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-moon-line text-xs" />
                  {t('album_luna.badge1')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-user-smile-line text-xs" />
                  {t('album_luna.badge2')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-music-line text-xs" />
                  {t('album.temas_badge')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-download-cloud-line text-xs" />
                  {t('album.descarga_badge')}
                </span>
                <span className="inline-flex items-center gap-1.5 font-sans text-xs font-medium text-[#5C4A3A] bg-white border border-sand/40 px-3 py-1.5 rounded-full">
                  <i className="ri-infinity-line text-xs" />
                  {t('album.uso_badge')}
                </span>
              </div>
              <div className="flex items-baseline gap-3 mb-6">
                <span className="font-serif text-4xl md:text-5xl font-bold text-[#8B6F5C]">$9.99</span>
                <span className="font-sans text-sm text-[#5C4A3A]">{t('common.usd')} — {t('common.pago_unico')}</span>
              </div>
              <ComingSoonCta />
            </div>
          </div>
          <div className="w-full h-[320px] md:h-[420px] rounded-3xl overflow-hidden">
            <img
              src={heroImage}
              alt="Madre meciendo a su bebé en ritual nocturno con luz cálida"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>

      {/* Sinopsis */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-moon-clear-line text-3xl text-cream" />
          </div>
          <h2 className="font-serif text-2xl md:text-4xl font-bold text-cream leading-tight mb-8">
            {t('album_luna.sinopsis.title')}
          </h2>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            Esta álbum no es música para dormir. Es música para el momento exacto en que el día termina y la noche comienza. Ese instante en que el ruido del mundo se apaga y solo quedan dos cuerpos en un cuarto en penumbra.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed mb-6">
            Cada pieza está diseñada para acompañar ese ritual: el baño, la luz baja, la última alimentación, el contacto. Y cuando la música se convierte en señal, el cerebro de tu bebé aprende algo que ninguna palabra puede enseñar: que el descanso es seguro, que la noche es un refugio, que vos estás ahí.
          </p>
          <p className="font-sans text-base md:text-lg text-cream leading-relaxed">
            No es una lista de canciones. Es una conversación entre tu bebé y la noche. Y vos en el medio, sosteniendo los dos mundos.
          </p>
        </div>
      </section>

      {/* Neurociencia */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-white">
        <div className="w-full max-w-5xl mx-auto">
          <div className="flex flex-col md:flex-row gap-8 md:gap-12 items-start">
            <div className="w-full md:w-1/2">
              <div className="w-14 h-14 rounded-2xl bg-[#AAB7A3]/20 flex items-center justify-center mb-6">
                <i className="ri-brain-line text-2xl text-[#AAB7A3]" />
              </div>
              <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#8B6F5C] leading-tight mb-6">
                {t('album_luna.ciencia.title')}
              </h2>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                Cada sonido de este álbum está diseñado para hablar directamente al sistema límbico del bebé: piano minimalista, nota a nota, sin distracciones. La música es como la respiración: no necesita ser entendida, solo sentida.
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed mb-4">
                El piano minimalista reduce la complejidad auditiva. El cerebro del bebé, que está aprendiendo a procesar miles de estímulos nuevos cada día, encuentra en el piano una estructura predecible y calmante. Cada acorde es un paso hacia el silencio.
              </p>
              <p className="font-sans text-base text-[#3D2B1F] leading-relaxed">
                El cerebro del bebé es un sistema de asociaciones. Cuando esta música se repite cada noche, el cerebro aprende: <strong>cuando suena esto, es hora de descansar.</strong> No es magia. Es neuroplasticidad. Es memoria emocional. Es amor convertido en señal.
              </p>
            </div>
            <div className="w-full md:w-1/2">
              <div className="bg-cream rounded-3xl p-8 md:p-10 border border-sand/30">
                <h3 className="font-serif text-2xl font-bold text-[#8B6F5C] mb-6">
                  {t('album.que_incluye')}
                </h3>
                <ul className="flex flex-col gap-4">
                  {[
                    '10 temas de audio de alta calidad',
                    'Piano minimalista para calma cerebral',
                    'Melodías suaves sin distracciones instrumentales',
                    'Diseñado para acompañar el ritual nocturno',
                    'Activación del sistema nervioso parasimpático',
                    'Reducción de cortisol en bebés y mamás',
                    'Descarga inmediata tras la compra',
                    'Uso ilimitado en todos tus dispositivos',
                  ].map((item) => (
                    <li key={item} className="flex items-center gap-3">
                      <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#AAB7A3]/20 flex-shrink-0">
                        <i className="ri-check-line text-[#AAB7A3] text-sm" />
                      </div>
                      <span className="font-sans text-sm text-[#3D2B1F]">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Track List */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto">
          <div className="text-center mb-12 md:mb-16">
            <span className="inline-block font-sans text-xs font-semibold text-terracotta uppercase tracking-[0.2em] mb-4">
              {t('album.lista_temas')}
            </span>
            <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
              {t('album_luna.tracks_title')}
            </h2>
            <p className="font-sans text-base text-[#3D2B1F] max-w-2xl mx-auto">
              Cada tema está diseñado para acompañar una fase del ritual nocturno. Juntos, forman la conversación más antigua entre una mamá y su bebé: la que dice, sin palabras, que la noche es segura.
            </p>
          </div>

          <div className="space-y-3">
            {tracks.map((track) => (
              <div
                key={track.number}
                className="flex items-baseline gap-3 font-sans text-base md:text-lg text-[#3D2B1F]"
              >
                <span className="font-medium text-[#8B6F5C] w-7 flex-shrink-0">
                  {track.number}
                </span>
                <span className="flex-1">
                  {track.title} — {track.desc}
                </span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cierre emocional */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-[#4A3F35]">
        <div className="w-full max-w-3xl mx-auto text-center">
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-8">
            <i className="ri-moon-clear-line text-3xl text-cream" />
          </div>
          <p className="font-serif text-2xl md:text-3xl text-cream leading-relaxed mb-8">
            &ldquo;Hay una melodía que tu bebé va a aprender a esperar cada noche — no porque se la enseñes con palabras, sino porque la repetición le va a enseñar, noche tras noche, que cuando suena esto, el mundo se detiene y llega la calma. No hace falta que cantes bien. No hace falta que hagas nada más que estar cerca mientras esto suena. El piano hace el resto: le habla directo al cuerpo de tu bebé, bajándole el ritmo antes de que las palabras puedan. Este álbum va a acompañar cientos de noches en tu casa. Que sea, desde la primera, una promesa de calma que se cumple siempre.&rdquo;
          </p>
          <div className="w-16 h-px bg-cream/30 mx-auto mb-8" />
          <p className="font-sans text-base text-cream/80 leading-relaxed">
            — Mercedes, NeuroBabys
          </p>
        </div>
      </section>

      {/* Final CTA */}
      <section className="py-16 md:py-24 px-6 md:px-10 bg-cream">
        <div className="w-full max-w-3xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-[#8B6F5C] leading-tight mb-4">
            {t('album_luna.cta.title')}
          </h2>
          <p className="font-sans text-base text-[#3D2B1F] max-w-xl mx-auto mb-8">
            {t('album_luna.cta.desc')}
          </p>
          <div className="flex items-center justify-center gap-3 mb-8">
            <span className="font-serif text-5xl md:text-6xl font-bold text-[#8B6F5C]">$9.99</span>
            <span className="font-sans text-base text-[#5C4A3A]">USD</span>
          </div>
          <ComingSoonCta size="lg" className="mb-4" />
          <p className="font-sans text-sm text-[#5C4A3A]">
            {t('album.descarga_footer')}
          </p>
        </div>
      </section>

      <Footer />
    </div>
  );
}